import { SharingDraft, StoreFont } from '@/types';
import { fetchSpecialFontTask } from '@/model/font/fetchSpecialFontTask';
import { ensureFontIsAddedToDocumentAction } from '@/redux/core/actions/ensureFontIsAddedToDocumentAction';
import { getFonts } from '@/redux/core/getters/getFonts';
import { getSpecialFonts } from '@/redux/core/getters/getSpecialFonts';
import { fetchDesignAction } from '@/redux/designs/actions/fetchDesignAction';
import { getPrintTypes } from '@/redux/printTypes/getters/getPrintTypes';
import { fetchProductTypeAction } from '@/redux/productTypes/actions/fetchProductTypeAction';
import { StoreDispatch, StoreState } from '@/redux/types';
import { mapSharingDraftToDraft } from './mapSharingDraftToDraft';

export const mapSharingDraftToDraftWithRedux = (
  sharingDraft: SharingDraft,
  state: StoreState,
  dispatch: StoreDispatch
) =>
  mapSharingDraftToDraft(
    sharingDraft,
    getPrintTypes(state),
    getFonts(state),
    getSpecialFonts(state),
    state.masks,
    {
      getProductType: (productTypeId: string) => dispatch(fetchProductTypeAction(productTypeId)),
      getDesign: (designId: string) => dispatch(fetchDesignAction(designId)),
      getLoadedFont: (font: StoreFont) => dispatch(ensureFontIsAddedToDocumentAction(font)),
      getSpecialFontTask: (fontId: string, align: string, text: string) =>
        dispatch(fetchSpecialFontTask(fontId, align, text)),
    }
  );
